
/*
  This component will display steps in configurator
 */

import React from 'react'
import { useSelector } from "react-redux";
import PatternAttribute from "./PatternAttribute";
import PatternOption from "./PatternOption";
import RowConfigStep from "../RowConfigStep";

const PatternSide = (props) => {
    const exceptions = useSelector(state => state.patternExceptions)
    const product = useSelector(state => state.productDataReducer)
    const sideKey = props.sideKey;
    const side = props.sideData[sideKey];
    const perModuleAttributes = side.sidePerModuleAttributes;
    const perModuleSelections = side.sidePerModuleSelections;

    const generateKey = (type, id) => {
        return `configurator_pattern_${type}_${id}`;
    }

    const patternAttributes = () => {
        if(!side) {
            return;
        }
        // since pattern attributes can have multiple, we need to render them similarily
        // to existing attributes
        const attributes = side.sideRequiredAttributes;
        const selections = side.sideRequiredSelections;
        const patternAttributes = selections ? selections : null;
        const toRender = [];
        attributes.forEach(function(el, index){
            // check store for a selection for this attribute, and pass it to children
            const currentSelection = patternAttributes ? patternAttributes.find((attr) => attr.id == el.id) : null;
            const currentValue = currentSelection ? currentSelection.selection : null;
            // we skip if an array because it is the array of product attributes already presented,
            // not side attributes.
            if(!Array.isArray(el)) {
                toRender.push(<PatternAttribute key={generateKey('attribute', el.id)} attribute={el} patternSideKey={sideKey} exceptions={exceptions} currentValue={currentValue}  product={product}/>)
            }
        })

        return ( toRender );
    }

    const patternOptions = () => {
        if(!side) {
            return;
        }
        if(shouldShowOptions(sideKey)) {
            const options = side.sideOptionalAttributes;
            const selections = side.sideOptionalSelections;
            return (
                [<PatternOption options={options} selections={selections} patternSideKey={sideKey} product={product} />,
                <RowConfigStep selections={perModuleSelections} attributes={perModuleAttributes} side={sideKey}/>]
            );
        } else {
            return;
        }
    }

    const shouldShowOptions = () => {
        if(!side){
            return
        }
        const availableAttributes = side.sideRequiredAttributes
        const selectionLength = side.sideRequiredSelections.length

        // if length of available attributes matches selected, we should show options
        return selectionLength == availableAttributes.length
    }


    return (
        <div key={generateKey('side', sideKey )} style={{position: 'relative'}}>
            {/*onMouseLeave={() => hideExceptionMessage()}*/}
            <div className="configurator-step pattern-side" >
                <div className="pattern-title-wrapper">
                    <h2>{ props.corner ? sideKey : "Side " + sideKey }</h2>
                </div>
                <div className="row side-attributes">
                    { patternAttributes() }
                    { patternOptions() }
                </div>
            </div>
        </div>
    )
}

export default PatternSide;
